import React from 'react';

function Malta(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124049)">
        <rect width="36" height="24" fill="#F7FCFF" />
        <mask
          id="mask0_800_124049"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124049)">
          <mask id="path-4-inside-1_800_124049" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.25 4H6.75V6.99254C6.25436 7.09705 5.88565 7.49303 5.88565 7.96556C5.88565 7.97709 5.88587 7.98857 5.88631 8H2.25V12H5.99709C6.1424 12.2674 6.41767 12.4685 6.75 12.5386V16H11.25V12.5514C11.6141 12.4966 11.9186 12.2863 12.0742 12H15.75V8H12.185C12.1854 7.98857 12.1856 7.97709 12.1856 7.96556C12.1856 7.47064 11.7811 7.0597 11.25 6.97967V4Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.25 4H6.75V6.99254C6.25436 7.09705 5.88565 7.49303 5.88565 7.96556C5.88565 7.97709 5.88587 7.98857 5.88631 8H2.25V12H5.99709C6.1424 12.2674 6.41767 12.4685 6.75 12.5386V16H11.25V12.5514C11.6141 12.4966 11.9186 12.2863 12.0742 12H15.75V8H12.185C12.1854 7.98857 12.1856 7.97709 12.1856 7.96556C12.1856 7.47064 11.7811 7.0597 11.25 6.97967V4Z"
            fill="#A0A0A0"
          />
          <path
            d="M6.75 4V3H5.75V4H6.75ZM11.25 4H12.25V3H11.25V4ZM6.75 6.99254L6.95633 7.97102L7.75 7.80366V6.99254H6.75ZM5.88631 8V9H6.92511L6.88558 7.96195L5.88631 8ZM2.25 8V7H1.25V8H2.25ZM2.25 12H1.25V13H2.25V12ZM5.99709 12L6.8757 11.5225L6.59174 11H5.99709V12ZM6.75 12.5386H7.75V11.7274L6.95633 11.5601L6.75 12.5386ZM6.75 16H5.75V17H6.75V16ZM11.25 16V17H12.25V16H11.25ZM11.25 12.5514L11.101 11.5626L10.25 11.6908V12.5514H11.25ZM12.0742 12V11H11.4795L11.1956 11.5225L12.0742 12ZM15.75 12V13H16.75V12H15.75ZM15.75 8H16.75V7H15.75V8ZM12.185 8L11.1857 7.96199L11.1462 9H12.185V8ZM11.25 6.97967H10.25V7.84028L11.101 7.96851L11.25 6.97967ZM6.75 5H11.25V3H6.75V5ZM7.75 6.99254V4H5.75V6.99254H7.75ZM6.88565 7.96556C6.88565 7.97901 6.88277 7.99211 6.87879 8.002C6.87511 8.01114 6.87228 8.01331 6.875 8.01029C6.88162 8.00294 6.90692 7.98144 6.95633 7.97102L6.54367 6.01405C5.67504 6.19722 4.88565 6.93435 4.88565 7.96556H6.88565ZM6.88558 7.96195C6.88563 7.96319 6.88565 7.9644 6.88565 7.96556H4.88565C4.88565 7.98978 4.88611 8.01394 4.88703 8.03805L6.88558 7.96195ZM2.25 9H5.88631V7H2.25V9ZM3.25 12V8H1.25V12H3.25ZM5.99709 11H2.25V13H5.99709V11ZM6.95633 11.5601C6.9242 11.5533 6.90129 11.5415 6.8874 11.5315C6.87325 11.5213 6.87213 11.5159 6.8757 11.5225L5.11847 12.4775C5.41523 13.0235 5.9492 13.3917 6.54367 13.517L6.95633 11.5601ZM7.75 16V12.5386H5.75V16H7.75ZM11.25 15H6.75V17H11.25V15ZM10.25 12.5514V16H12.25V12.5514H10.25ZM11.399 13.5403C12.0466 13.4427 12.6353 13.0618 12.9528 12.4775L11.1956 11.5225C11.1994 11.5155 11.1977 11.5222 11.1809 11.5336C11.1644 11.5447 11.1378 11.557 11.101 11.5626L11.399 13.5403ZM15.75 11H12.0742V13H15.75V11ZM14.75 8V12H16.75V8H14.75ZM12.185 9H15.75V7H12.185V9ZM11.1856 7.96556C11.1856 7.9644 11.1856 7.96321 11.1857 7.96199L13.1842 8.03801C13.1852 8.01393 13.1856 7.98978 13.1856 7.96556H11.1856ZM11.101 7.96851C11.1561 7.97681 11.1862 7.99979 11.1954 8.00933C11.1993 8.01345 11.1968 8.01218 11.193 8.00322C11.1888 7.99339 11.1856 7.97978 11.1856 7.96556H13.1856C13.1856 6.88385 12.3224 6.12997 11.399 5.99083L11.101 7.96851ZM10.25 4V6.97967H12.25V4H10.25Z"
            fill="#FECA00"
            mask="url(#path-4-inside-1_800_124049)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 0H36V24H18V0Z"
            fill="#E31D1C"
          />
          <mask
            id="mask1_800_124049"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="18"
            y="0"
            width="18"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 0H36V24H18V0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124049)" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124049">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Malta;
